import {cx} from '@emotion/css';
import React, {ReactElement} from 'react';
import {FormattedMessage} from 'react-intl';
import {GatsbyImage, IGatsbyImageData} from 'gatsby-plugin-image';

import styles from './PartnerLogo.styles';

export interface Props {
  logo: {
    title: string;
    gatsbyImageData?: IGatsbyImageData;
    file?: {
      url: string;
    };
  };
}

function PartnerLogo({logo}: Props): ReactElement {
  return (
    <div className={cx(styles.container)}>
      <div className={cx(styles.text)}>
        <FormattedMessage id="phoenix.partners.title" />
      </div>
      <div className={cx(styles.imageContainer)}>
        {logo.gatsbyImageData && (
          <GatsbyImage image={logo.gatsbyImageData} alt={logo.title} className={cx(styles.image)} objectFit="contain" />
        )}
        {!logo.gatsbyImageData && logo.file?.url && (
          <img src={logo.file.url} alt={logo.title} className={cx(styles.image)} />
        )}
      </div>
    </div>
  );
}

export default PartnerLogo;
